import { createFileRoute } from "@tanstack/react-router";
import { AccessDeniedPage } from "@/pages/AccessDenied/AccessDeniedPage";

export const Route = createFileRoute("/access-denied")({
  component: AccessDeniedPage,
});
